import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerReceivablesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  asOfDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type GetCustomerReceivablesQuery = { __typename?: 'Query', customerReceivables?: { __typename?: 'CustomerReceivables', customerId: string, openInvoices: Array<{ __typename?: 'CustomerReceivableInvoice', invoiceId: string, invoiceNumber: string, orderId: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, total: number, taxTotal: number, openBalance: number, daysPastDue: number, accruedLateCharge: number, lateChargeWaived: number, availableDiscount: number, standing: Types.InvoiceStanding }> } | null };

export type CustomerReceivableOpenInvoiceFragment = { __typename?: 'CustomerReceivableInvoice', invoiceId: string, invoiceNumber: string, orderId: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, total: number, taxTotal: number, openBalance: number, daysPastDue: number, accruedLateCharge: number, lateChargeWaived: number, availableDiscount: number, standing: Types.InvoiceStanding };

export type GetInvoicePaymentPreviewQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String']['input'];
  amount: Types.Scalars['Decimal']['input'];
  receivedDate: Types.Scalars['DateTime']['input'];
}>;


export type GetInvoicePaymentPreviewQuery = { __typename?: 'Query', invoicePaymentPreview: { __typename?: 'InvoicePaymentPreview', invoiceId: string, amount: number, discountTaken: number, lateChargeAssessed: number, settles: boolean } };

export type GetReceivablesAgingTotalsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReceivablesAgingTotalsQuery = { __typename?: 'Query', receivablesAgingTotals: { __typename?: 'ReceivablesAgingTotals', arBalance: number, current: number, days1To30: number, days31To60: number, days61To90: number, days90Plus: number, accruedLateCharges: number, openInvoiceCount: number, customersOwing: number } };

export type ReceivablesAgingTotalsFragment = { __typename?: 'ReceivablesAgingTotals', arBalance: number, current: number, days1To30: number, days31To60: number, days61To90: number, days90Plus: number, accruedLateCharges: number, openInvoiceCount: number, customersOwing: number };

export const CustomerReceivableOpenInvoiceFragmentDoc = new TypedDocumentString(`
    fragment CustomerReceivableOpenInvoice on CustomerReceivableInvoice {
  invoiceId
  invoiceNumber
  orderId
  invoiceDate
  dueDate
  total
  taxTotal
  openBalance
  daysPastDue
  accruedLateCharge
  lateChargeWaived
  availableDiscount
  standing
}
    `, {"fragmentName":"CustomerReceivableOpenInvoice"});
export const ReceivablesAgingTotalsFragmentDoc = new TypedDocumentString(`
    fragment ReceivablesAgingTotals on ReceivablesAgingTotals {
  arBalance
  current
  days1To30
  days31To60
  days61To90
  days90Plus
  accruedLateCharges
  openInvoiceCount
  customersOwing
}
    `, {"fragmentName":"ReceivablesAgingTotals"});
export const GetCustomerReceivablesDocument = new TypedDocumentString(`
    query GetCustomerReceivables($customerId: String!, $asOfDate: DateTime) {
  customerReceivables(customerId: $customerId, asOfDate: $asOfDate) {
    customerId
    openInvoices {
      ...CustomerReceivableOpenInvoice
    }
  }
}
    fragment CustomerReceivableOpenInvoice on CustomerReceivableInvoice {
  invoiceId
  invoiceNumber
  orderId
  invoiceDate
  dueDate
  total
  taxTotal
  openBalance
  daysPastDue
  accruedLateCharge
  lateChargeWaived
  availableDiscount
  standing
}`);
export const GetInvoicePaymentPreviewDocument = new TypedDocumentString(`
    query GetInvoicePaymentPreview($invoiceId: String!, $amount: Decimal!, $receivedDate: DateTime!) {
  invoicePaymentPreview(
    invoiceId: $invoiceId
    amount: $amount
    receivedDate: $receivedDate
  ) {
    invoiceId
    amount
    discountTaken
    lateChargeAssessed
    settles
  }
}
    `);
export const GetReceivablesAgingTotalsDocument = new TypedDocumentString(`
    query GetReceivablesAgingTotals {
  receivablesAgingTotals {
    ...ReceivablesAgingTotals
  }
}
    fragment ReceivablesAgingTotals on ReceivablesAgingTotals {
  arBalance
  current
  days1To30
  days31To60
  days61To90
  days90Plus
  accruedLateCharges
  openInvoiceCount
  customersOwing
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerReceivables: build.query<GetCustomerReceivablesQuery, GetCustomerReceivablesQueryVariables>({
      query: (variables) => ({ document: GetCustomerReceivablesDocument, variables })
    }),
    GetInvoicePaymentPreview: build.query<GetInvoicePaymentPreviewQuery, GetInvoicePaymentPreviewQueryVariables>({
      query: (variables) => ({ document: GetInvoicePaymentPreviewDocument, variables })
    }),
    GetReceivablesAgingTotals: build.query<GetReceivablesAgingTotalsQuery, GetReceivablesAgingTotalsQueryVariables | void>({
      query: (variables) => ({ document: GetReceivablesAgingTotalsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerReceivablesQuery, useLazyGetCustomerReceivablesQuery, useGetInvoicePaymentPreviewQuery, useLazyGetInvoicePaymentPreviewQuery, useGetReceivablesAgingTotalsQuery, useLazyGetReceivablesAgingTotalsQuery } = injectedRtkApi;
